import { useMutation } from "react-query";
import {
  SharedLicensePlateRequestParams,
  deleteSharedLicensePlate,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const deleteSharedLicensePlateFn = async (
  params: SharedLicensePlateRequestParams
) => {
  return await deleteSharedLicensePlate(params);
};

export function useDeleteSharedLicensePlate() {
  return useMutation(deleteSharedLicensePlateFn, {
    mutationKey: MUTATION_KEYS.deleteSharedLicensePlate,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
